/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FC } from 'react';
import { Typography, Stack, Button } from '@mui/material';

import TestIds from '../../../../testIds';

export interface ICostPriceErrorProps {
  onTryAgain: () => void;
}

const CostPriceError: FC<ICostPriceErrorProps> = ({
  onTryAgain,
}: ICostPriceErrorProps): JSX.Element => (
  <Stack
    data-testid={TestIds.feat.costPrice.error.component}
    spacing='1rem'
    alignItems='center'
    justifyContent='center'
    minHeight='150px'
  >
    <Typography variant='default' color='accent'>
      Unable to load cost prices for this product.
    </Typography>

    <Button
      variant='farmlands2.0_default'
      color='primary'
      data-testid={TestIds.feat.costPrice.error.tryAgainBtn}
      onClick={onTryAgain}
    >
      Try again
    </Button>
  </Stack>
);

export default CostPriceError;
